import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {ApisService} from '../../apis/apis.service';
import {MessageService} from '../message/message.service';
import {UserService} from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class UserCheckEntitlementsService {

  constructor(
    private activatedRoute: ActivatedRoute,
    private apisService: ApisService,
    private messageService: MessageService,
    private router: Router,
    private userService: UserService) {
  }

  public checkEntitlements() {
    // return this.apisService.getApis({limit: 1}).toPromise()
    return this.apisService.checkEntitlements().toPromise()
      .then(response => {
        this.userService.init()
          .then(() => {
            this.router.navigateByUrl(this.activatedRoute.snapshot.queryParams.target);
          });
      })
      .catch((httpErrorResponse: HttpErrorResponse) => {
        const is401 = httpErrorResponse.status === 401;
        if (is401) { // Note that server has already signed us out
          this.userService.handleHttpError401();
        }
        this.messageService.error(is401 ?
          'This account is not entitled to use this site.' :
          `Error checking entitlements. ${httpErrorResponse.statusText}.`
        );
        this.router.navigateByUrl('home'); // undesirable to remain on the current route /check-entitlements
      });
  }
}
